module.exports = __webpack_public_path__ + "static/media/ga.dcc86809.png";